import React, { useContext } from 'react';

// DEPENDENCIES
import { useFormikContext } from 'formik';

// HELPERS
import { RecordContext } from 'helpers/getRecordData';

// GLOBAL VARIABLES
import { RETAIL_WHOLESALE, WHOLESALE_FORMAT } from 'codes';

// LOCAL COMPONENTS
import Card from '../parts/Card';

// SALES COMPONENTS
import CustomerInfo from '../../sales/view/parts/CustomerInfo';
import DealerIncentives from '../../sales/view/parts/DealerIncentives';
import DealerPacks from '../../sales/view/parts/DealerPack';
import DownPaymentDeposit from '../../sales/view/parts/DownPayment';
import EmployeeInfo from '../../sales/view/parts/EmployeeInfo/EmployeeInfo';
import InternalDeal from '../../sales/parts/InternalDealRecap';
import InventoryInternal from '../../sales/parts/InventoryInternal';
import PricingInfo from '../../sales/view/parts/PricingInfo/PricingInfo';
import PurchaseInfo from '../../sales/view/parts/PurchaseInfo';
import Rebates from '../../sales/view/parts/Rebate';
import MiscItems from '../../sales/view/parts/MiscItems';
import Status from '../../sales/view/parts/Status/Status';
import TradeInfo from '../../sales/view/parts/Trade';
import VehicleInfo from '../../sales/view/parts/VehicleInfo';
import VehicleRegistration from '../../sales/view/parts/VehicleRegistration';
import WholeSaleInfo from './WholeSaleInfo';
import SaleAttachment from './SaleAttachment';

// GLOBAL COMPONENTS
import Form from 'core/form/Form';

// STYLES
import styles from './saleVehicleInfo.module.scss';

// MAIN COMPONENT
const SaleVehicleInfoSections = ({ isFinanceManager, isOrder }) => {
  const { values: { sale_type_category_code, wholesale_format_id } = {} } = useFormikContext() || {};

  const isWholesale = sale_type_category_code === RETAIL_WHOLESALE.wholesale.category_code;
  const isWholesaleSimplified = isWholesale && wholesale_format_id === WHOLESALE_FORMAT.simplified.numeric;

  return (
    <>
      <Status />
      {isOrder && isWholesale ? <WholeSaleInfo /> : <CustomerInfo />}
      {!isWholesaleSimplified && (
        <>
          <VehicleRegistration />
          <EmployeeInfo />
        </>
      )}
      <VehicleInfo />
      <PricingInfo />
      <InventoryInternal />
      <PurchaseInfo />
      <TradeInfo />
      {!isWholesaleSimplified && <Rebates />}
      <MiscItems />
      <DealerIncentives />
      <DealerPacks />
      {!isWholesaleSimplified && <DownPaymentDeposit />}
      <InternalDeal />
      {!isOrder && isFinanceManager && <SaleAttachment />}
    </>
  );
};

// EXPORT
export default function SaleVehicleInfo({ isFinanceManager, isOrder }) {
  const { record: initialValues = {} } = useContext(RecordContext) || {};

  return (
    <Card
      title="Sale / Vehicle Info"
      className={styles.container}
      body={
        <Form initialValues={initialValues}>
          <SaleVehicleInfoSections isFinanceManager={isFinanceManager} isOrder={isOrder} />
        </Form>
      }
    />
  );
}
